<template>
  <div class="invite-wrap">
    <p class="fine-print">Tip: You can copy and paste multiple emails at once.</p>
    <div class="form-area">
      <div class="form-row">
        <p ref="name-error" class="field-error" :class="{ 'show-error' : listError }">Grrr... You haven't entered any valid email addresses.</p>
        <div class="text-area-section input-wrap" :class="{ 'show-error' : listError }">
          <textarea @keydown="emitChange($event.key)"
            id="textarea"
            name="invite-list"
            v-model="inputString"
            autocomplete="off"
            autocorrect="off"
            autocapitalize="off"
            spellcheck="false"></textarea>
        </div>
      </div>
    </div>
    <div v-if="emailList.length > 0" class="success">
      <div class="valid-emails">
        <p>
          <template v-for="email in emailList">
            <span v-bind:key="email">
              <span class="valid-email">
                {{email}}
                <button class="plain close" @click="removeEmail(email)" :aria-label="'remove ' + email">✖</button>
              </span>
            </span>
          </template>
        </p>
      </div>
      <p v-if="nEmails">You are inviting <strong>{{nEmails}} member<span v-if="nEmails > 1">s</span></strong> to join your team.</p>
    </div>
    <div class="btn-wrap">
      <p v-if="errorMessage && nEmails < 1" class="alert alert-danger">{{errorMessage}}</p>
      <submit-button @submit="sendInvites" :finished="finished">Send Invites</submit-button>
    </div>
  </div>
</template>

<script>
import submitButton from '@/components/submit-button/submit-button'
import is from 'is_js'

export default {
  name: 'invite-portal',
  components: {
    'submit-button': submitButton
  },
  data () {
    return {
      inputString: '',
      is: is,
      listError: false,
      errorMessage: '',
      finished: false,
      txt: 'Edit me',
      emails: []
    }
  },
  computed: {
    emailList: function () {
      let list = this.inputString.split(/[\s,;]+/)
      return list.filter((el, index) => is.email(el) && list.indexOf(el) === index)
    },
    nEmails: function () {
      return this.emailList.length
    }
  },
  methods: {
    emitChange: function (key) {
      this.$emit('typing', key)
    },
    removeEmail: function (email) {
      this.inputString = this.inputString.replace(email, '')
      this.emitChange('Backspace')
    },
    onEdit: function (e) {
      let list = e.target.innerText.split(/[\s,;]/g).filter((el) => !!el)
      let emails = []
      for (let i = 0; i < list.length; i++) {
        if (is.email(list[i])) {
          emails.push(list[i])
          list.splice(i, 1)
        }
      }
      this.emails = emails
      this.txt = list.join('')
    },
    sendInvites: function () {
      if (this.nEmails === 0) {
        this.listError = true
        return
      }
      this.$store.dispatch('submitting', true)
      this.$http.post(this.ENV.coreBaseUrl + '/team/invite', {
        emails: this.emailList
      }).then(response => {
        this.$store.dispatch('newTeamInviteCount', this.nEmails)
        this.$store.dispatch('submitting', false)
        this.$store.dispatch('getPendingData', true)
        this.finished = true
        setTimeout(() => {
          this.$emit('inviteSuccess')
        }, 1500)
      }).catch(error => {
        this.errorMessage = 'Grrr... Something went wrong with your request.'
        this.$store.dispatch('submitting', false)
      })
    }
  }
}
</script>

<style scoped lang="stylus" src="./invite-portal.styl" >



// WEBPACK FOOTER //
// src/components/invite-portal/invite-portal.vue